import React from 'react';
import {Route, Routes} from 'react-router-dom';
import ItemsPage from './pages/ItemsPage';
import InventoryPage from './pages/InventoryPage';
import InventoryLocationPage from './pages/inventoryLocationPage';
import ItemCategoriesPage from './pages/itemsCategoryPage';
import ItemsLocationPage from './pages/itemsLocationPage';
import ItemTransfersPage from './pages/itemTransferPage';
import ItemsIssuedPage from './pages/itemsIssuedPage';
import BackOrdersPage from './pages/backOrdersPage';
import GrvsPage from './pages/grvsPage';
import GivsPage from './pages/givsPage';

const InventoryRoutes = () => {
  return (
    <Routes>
      <Route path="/locations-stock" element={<ItemsLocationPage />} />
      <Route path="/create-inventory" element={<InventoryPage />} />
      <Route path="/items" element={<ItemsPage />} />
      <Route path="/inventory-locations" element={<InventoryLocationPage />} />
      <Route path="/item-categories" element={<ItemCategoriesPage />} />
      <Route path="/item-transfers" element={<ItemTransfersPage />} />
      <Route path="/items-issued" element={<ItemsIssuedPage />} />
      <Route path="/back-orders" element={<BackOrdersPage />} />
      <Route path="/grvs" element={<GrvsPage />} />
      <Route path="/givs" element={<GivsPage />} />
    </Routes>
  );
}

export default InventoryRoutes;
